export default {
  pim: "PIM",
  Root: {
    Basic: {
      Failed: "Failed",
      Success: "Success",
      Result: "Result",
      Select: "Select",
      Cancel: "Cancel",
      Confirm: "Confirm",
      OK: "OK",
      Ok: "OK",
      Tips: "Tips",
      Warning: "Warning",
      Method: "Method",
      Required: "Required",
      MaxLength: "The length is limited to {num} characters",
      Submit: "Submit",
      Search: "Search",
      Reset: "Reset",
      More: "More"
    },
    Layout: {
      Expand_the_sider_menu: "Expand the sider menu",
      Collapse_the_sider_menu: "Collapse the sider menu",
      please_select: "Please select",
      Change_Password: "Change Password",
      Log_out: "Log out",
      My_Applications: "My Applications",
      salesChannels: "Sales Channels",
      search_org: "Search org name",
      search_2_org: "Search for the name of the secondary org"
    },
    Import: {
      Job: "Job",
      No: "No.",
      row_of_sheet: "Row of sheet",
      reason_of_fails: "Reason of fails",
      File: "File",
      no_data: "No results found",
      import: "Import",
      upload: "Upload",
      refresh: "Refresh",
      refresh_notice: "Click on “Refresh” to view the latest status.",
      view_result: "View Result",
      Started_at: "Started at",
      Status: "Status",
      total_count: "Total Count",
      error_count: "Error Count",
      Action: "Action",
      got_it: "Got it!",
      execution_history: "Execution History",
      import_history: "Import History",
      download_template: "Download Template",
      job_description: "Job Description",
      import_products: "Import Products",
      import_completed_at: "Import completed at",
      importing:
        "Importing, please be patient. The result will be displayed in the execution history list.",
      import_products_desc:
        "You can import products to PIM from a XLSX file. We recommend downloading the template before running an import.",
      select_a_file: "Select a file",
      Please_select_an_org: " Please select an organization first",
      rules_title: "Import Rules",
      import_run_tip: "When the import is running,you can not view result",
      Please_confirm_the_org:
        "Please confirm the organization where the product needs to be imported",
      Confirme_or_switch_org: "Confirme or switch organization",
      Import_Products: "Import Products",
      Import_SKU: "Import SKU",
      Import_Price: "Import Price",
      Import_Image: "Import Image",
      Import_Channel_Info: "Import Channel Info",
      DownloadTemplate: "Download Source File"
    },
    Picker: {
      ByCondition: "By conditions",
      Byproduct: "By product",
      BySKU: "By SKU",
      Sku_code_sku_name: "SKU Name / SKU Code",
      Enter_sku_to_search: "Enter SKU code or product code to search",
      ORG: "Org",
      Find_product_throung_search: "Find and add product throung search.",
      Required: "Required",
      Select_ORG: "Select Org",
      Condition_products: "Condition products",
      Please_select_at_least_options: "Please select at least one option",
      Download_Template: "Download Template",
      Select_a_file: "Select a file",
      Will_overwrite_the_p:
        "Will overwrite the previously imported data, confirm to upload ?",
      Attributes: "Attributes",
      skuAttributes: "SKU attributes",
      spuAttributes: "Product attributes",
      Only_select_attribut:
        "Only attributes of Single/Multi Select type can be used as filter conditions.",
      Only_select_up_to_th: "Select up to {max} attributes",
      Add_attribute: "Add attribute",
      Please_select_at_least_attribute:
        "Please select at least one attribute value",
      Manual: "Manual",
      Import: "Import",
      Selected_items: "Selected items ({total})",
      Enter_product_name_to_search: "Enter product name or code to search",
      Product_code: "Product code",
      Product_name: "Product name",
      You_can_select_produ:
        "You can select products from a XLSX file. We recommend downloading the template before uploading.",
      Imported_Products: "Imported Products",
      Enter_SKU_code_to_search: "Enter SKU code to search",
      Sku_name: "SKU name",
      Sku_code: "SKU code",
      You_can_select_SKU_f:
        "You can select SKU from a XLSX file. We recommend downloading the template before uploading.",
      Imported_Skus: "Imported SKUs",
      Select: "Select",
      Select_all_products: "Select all products",
      Select_attribute: "Select attribute",
      Upload: "Upload",
      Cancel: "Cancel",
      Yes: "Yes",
      Categories: "Categories",
      Brands: "Brands",
      EmptyFile: "Empty File",
      ByTags: "By Tags",
      Method: "Method",
      ByMobile: "By Mobile",
      ByUserID: "By User ID",
      Repeat: "Repeat",
      upload_xlsx_err: "Please upload the correct form data!"
    },
    Export: {
      export: "Export",
      export_all: "Export All",
      history: "Export History",
      time: "Export Time",
      requester: "Requester",
      language: "Language",
      status: "Status",
      action: "Action",
      no_history: "No history",
      choose_language: "Choose Language",
      loading: "Loading...",
      download: "Download",
      refresh_notice: "Click on “Refresh” to view the latest status.",
      page_notice:
        "Export products, attributes or other information to a local file.",
      exporting: "Product data is being prepared for download...",
      refresh: "Refresh",
      export_all_notice:
        "Are you sure to export all products? This can take long time if there're a lot products."
    },
    MemberPicker: {
      required: "Required",
      Enter_user_id_separated_by: "Enter user ID separated by ‘,’",
      Enter_mobile_separated_by: "Enter mobile separated by ‘,’",
      Search_tag: "Enter tag name to search",
      selected_members: "Selected members"
    },
    TimeLine: {
      OperationLog: "Operation Log",
      View_More: "View More",
      Callpase: "Callpase",
      No_Data: "No Data"
    },
    Clipboard: {
      Success: "Copied: {content}",
      ToCopy: "Click to copy"
    },
    Upload: {
      select_tip: "Plase select file!"
    },
    HeaderSearchStore: {
      Switch_Org: "Switch Org",
      All_Stores: "All Stores",
      Online_Store: "Online Store",
      Offline_Store: "Offline Store"
    }
  },
  Brand: {
    brand: "Brand",
    Brand_Name: "Brand Name",
    Brand_Code: "Brand Code",
    Brand_Logo: "Brand Logo",
    confirm_delete_brand_warning: "Are you sure to delete brand？",
    search_brand_placeholder: "Type brand name to search",
    input_brand_name: "Brand Name is require"
  },
  Category: {
    category: "Category",
    create_root_category: "Create root category",
    category_name: "Category Name",
    category_code: "Category Code",
    category_delete:
      "This will delete the category and its sub categories. Do you wish to continue?",
    input_category_name: "Category Name is require",
    category_Logo: "Category Logo"
  },
  Product: {
    product: "Product",
    product_name: "Product Name",
    product_status: "Status",
    search_product_placeholder: "Type product name or code to search",
    add_sku: "Add sku",
    add_attr: "Add attribute",
    price: "Price",
    sale_price: "Sale Price",
    media: "Media",
    mb_media: "Mobile Media",
    sku: "SKU",
    sku_status: "SKU Status",
    properties: "Properties",
    attributes: "Attributes",
    description: "Description",
    deactivate: "Deactivate",
    activate: "Activate",
    inactive: "Inactive",
    media_des: "Photos or videos",
    mb_media_des: "Mobile photos or videos",
    pictures: "Pictures",
    required_20_char_num_let: "Must be 1-20 digits or letters",
    channel: "Channel",
    region_code: "Region Code",
    // product: "Product",
    // product_name: "Product Name",
    // product_status: "Status",
    // search_product_placeholder: "Type product name or code to search",
    // add_sku: "Add SKU",
    // add_attr: "Add attribute",
    list_price: "List Price",
    // price: "Price",
    // sale_price: "Sale Price",
    // media: "Media",
    // mb_media: "Mobile Media",
    // sku: "SKU",
    // sku_status: "SKU Status",
    // properties: "Properties",
    // attributes: "Attributes",
    // description: "Description",
    // deactivate: "Deactivate",
    // activate: "Activate",
    // inactive: "Inactive",
    // media_des: "PC - Photos & Videos ({num})",
    // mb_media_des: "Mobile - Photos & Videos ({num})",
    // pictures: "Pictures",
    // required_20_char_num_let: "Must be 1-20 digits or letters",
    required_50_char_num_let: "Must be 1-50 digits or letters",
    // channel: "Channel",
    // region_code: "Region Code",
    external_code: "External Code",
    system_auto_creatd_unique_across_org:
      "System auto created & unique across org",
    user_created_unique_within_org: "User created & unique within org",
    code_used_in_user_own_system: "Code used in user own system (eg. ERP )",
    list_product: "Do you need to list this product",
    product_code: "Product Code",
    product_number: "Product Number",
    brand: "Brands",
    categories: "Categories",
    onboard_time: "Onboard Time",
    create_time: "Create Time",
    barcode: "Barcode",
    viewChannel: "View channel SKU code",
    Channel: "Channel",
    Channel_sku_code: "Channel SKU Code",
    require: "Require",
    selected: "selected",
    image: "Image",
    sort: "Sort",
    delivery_product: "Delivery product",
    service_product: "Service product",
    virtual_product: "Virtual product",
    sku_code: "SKU Code",
    sku_number: "SKU Number",
    sku_name: "SKU Name",
    sku_media: "SKU media",
    sku_empty: "Please add at least one SKU",
    sku_duplicate: "SKU Number duplicate",
    type: "Type",
    shopName: "Shop Name",
    export: "Export",
    success_export: "Export request submitted successfully.",
    export_notice_title: "Export Products",
    export_submitted:
      "After exporting, please go to the “Export” menu to check the job status and download product file.",
    export_all: "You are requesting to export all products.",
    export_filter: "You are requesting to export filtered products.",
    view_export: "View Export Status",
    synchronous_price:
      "Do you wish to apply the product prices to all its SKU？",
    sku_save_info:
      'You have modified the SKU info, you need to click the "Save SKU" button to take effect. But if you modify the SKU status, it will take effect immediately.',
    publish_submited: "Publish Submited",
    view_result: "View Result",
    batch_empty: "Please select the product",
    batch_active_notice: "Are you sure you want to activate these products?",
    batch_deactive_notice:
      "Are you sure you want to deactivate these products?",
    no_active:
      "All the selected products have been activated, so there is no need to repeat the operation",
    no_deactive:
      "All the selected products have been dectivated, so there is no need to repeat the operation",
    batch_num: "You have selected {num} items in total, "
  },
  Attribute: {
    attribute_name: "Attribute Name",
    search_attr_placeholder: "Type attribute name to search",
    attribute: "Attribute",
    value_type: "Value Type",
    add_attribute: "Add Attribute",
    code: "Attribute Code",
    type: "Attribute Type",
    generate_sku: "Is used to identify SKU",
    is_Required: "Is Required",
    is_per_channel: "Is Per Channel",
    is_per_locale: "Is Per Locale",
    is_front_display: "Is Front Display",
    is_front_filterable: "Is Front Filterable",
    image: "Image",
    option: "Option",
    value_type_title: "Value Type",
    add_option: "Add New Option",
    edit_Languages: "Edit Multi-Languages",
    edit_Languages_2: "Edit Multi-Languages",
    option_placeholder: "Please Edit Multi-Languages",
    delete_option: "Delete Option",
    option_require: "Option is require",
    is_multi_language: "Is multi-language",
    product: "Product",
    Single_Select: "Single Select",
    Multiple_Select: "Multiple Select",
    Number: "Number",
    Text: "Text",
    Text_Area: "Text Area"
  },
  Order: {
    Order_no: "Order #",
    order: "Order #",
    store_name: "Store Name",
    store: "Store #",
    created_from: "Created from",
    created_to: "Created to",
    status: "Status",
    customer: "Customer",
    plate: "Plate #",
    mobile: "Mobile #",
    source: "Source",
    amount: "Amount",
    payment_type: "Paymt. Type",
    basic_info: "Basic Info",
    payment_info: "Payment Info",
    customer_info: "Customer Info",
    order_promotion: "Order Promotion",
    order_items: "Order Items",
    Channel: "Channel",
    Payment_account: "Payment account",
    Order_discount: "Order discount",
    Order_details: "Order details"
  },
  Basic: {
    Failed: "Failed",
    Result: "Result",
    Tips: "Tips",
    MaxLength: "The length is limited to {num} characters",
    Sure: "Sure",
    Action: "Action",
    Create: "Create",
    Edit: "Edit",
    Delete: "Delete",
    Search: "Search",
    Cancel: "Cancel",
    Continue: "Continue",
    Confirm: "Confirm",
    Warning: "Warning",
    no_empty: "Can not be empty",
    Next: "Next",
    Save: "Save",
    please_select: "Please select ",
    Add: "Add",
    Status: "Status",
    confirm_delete: "Are you sure to delete?",
    image: "Image",
    type: "Type",
    logo: "Logo",
    Switch: "Switch",
    tenant: "Tenant",
    org: "Org",
    prev: "Previous",
    success: "Success",
    create_time: "Create Time",
    return: "Return",
    View: "View",
    promotion: "Promotion",
    deduction: "Deduction",
    product_items: "Product Items",
    price: "Price",
    sale_price: "Sale Price",
    qty: "Qty.",
    amount: "Amount",
    payment: "Payment",
    Method: "Method",
    Time: "Time",
    customer_code: "Customer Code",
    name: "Name",
    monile: "Moblie",
    resv_time: "Resv. Time",
    order_amount: "Order Amount",
    return_amount: "Return Amount",
    order: "Order #",
    store_name: "Store Name",
    store: "Store #",
    created_from: "Created from",
    created_to: "Created to",
    status: "Status",
    customer: "Customer",
    plate: "Plate #",
    mobile: "Mobile #",
    source: "Source",
    payment_type: "Paymt. Type",
    basic_info: "Basic Info",
    payment_info: "Payment Info",
    customer_info: "Customer Info",
    order_promotion: "Order Promotion",
    order_items: "Order Items",
    Refund: "Refund",
    refund: "Refund #",
    return_no: "Return #",
    items_to_refund: "Items to Refund",
    change_log: "Change Log",
    change: "Change",
    User: "User",
    date_and_time: "Date & Time",
    refund_request_info: "Refund Request Info",
    cancel: "Cancel",
    sure: "Sure",
    title: "Title",
    type_store_name_or_code: "Type store name or code to search",
    create_to: "Create to",
    detail: "Detail",
    approve: "Approve",
    reject: "Reject",
    payment_no: "Payment #",
    refund_detail: "Refund Detail",
    return_detail: "Return Detail",
    return_request_info: "Return Request Info",
    items_to_return: "Items to Return",
    are_you_certain_to_cancel_the_order: "Are you certain to cancel the order?",
    Ok: "Ok",
    Reset: "Reset",
    Shop_Discount: "Shop Discount",
    Type_the_reason_for_cancel: "The reason of order cancel",
    Active: "Active",
    Inactive: "Inactive",
    More: "More",
    Complete: "Complete",
    Sure_message: "Are you certain to do this?",
    account: "Account",
    time: "Time",
    refund_amount: "Refund Amount",
    amount_discount: "Amount Discount",
    refund_apply_type: "Refund Apply Type",
    bank: "Bank",
    bank_account: "Bank Account",
    Remark: "Remark",
    Save_and_submit: "Save & submit",
    Enter_order_code: "Enter order code",
    Order_code_is_required: "Order code is required",
    Submit_again: "Submit again",
    submit: "Submit",
    type_reason_of_reject: "Type reason of reject",
    Complete_time: "Complete time",
    payment_account: "Payment account",
    Transaction_Fee: "Transaction Fee",
    Telphone: "Telephone",
    Telphone_: "Telephone #",
    Zipcode: "Zip code",
    Region: "Region",
    Address: "Address",
    Adress: "Adress",
    Carrier: "Carrier",
    Shipping_number: "Shipping number",
    Country: "Country",
    Province: "Province",
    City: "City",
    District: "District",
    Product_code: "Product Code",
    Bar_code: "Bar Code",
    Channel_sku: "Channel SKU #",
    Sub_order_number: "Sub Order Number",
    required_msg: "Is required",
    required_num_msg: "To enter a number",
    required_num_0: "Must be greater than 0",
    required_20_char: "Cannot exceed 20 characters",
    required_50_char: "Cannot exceed 50 characters",
    required_100_char: "Cannot exceed 100 characters",
    required_500_char: "Cannot exceed 500 characters",
    required_number_letter_dashes: "Can only be numbers, letters, dashes",

    No_empty: "Can not be empty",

    Save_as_draft: "Save as draft",
    Please_select: "Please select ",

    Create_time: "Create time",

    Title: "Title",
    Approve: "Approve",
    Reject: "Reject",

    Create_Time: "Create time",
    Close: "Close",
    Description: "Description",
    Submit: "Submit",

    Start_date: "Start date",
    End_date: "End date",

    Release: "Release",
    Send: "Send",

    Please_input_number: "Please input number",
    Can_not_be_empty: "Can not be empty",
    Must_be_a_positive_integer_greater_than_0:
      "Must be a positive integer greater than 0",
    Success: "Success",
    Total: "Total",
    Error: "Error",
    required: "Required",
    ok: "OK",
    Create_Order: "Create Order",
    Store_No: "Store No.",
    Please_select_product: "Please select a product",
    Please_add_payment_method: "Please add at least one payment method",
    Node: "Node",
    Channel_Order_No: "Channel Order No.",
    Mobile_No: "Mobile No.",
    Telephone_No: "Telephone No.",
    Order: "Order",
    // Create_Time: "Create Time",
    Sync_Time: "Sync Time",
    Error_Msg: "Error Msg",
    After_Sync_Qty: "After Sync Qty",
    Sync_Qty: "Sync Qty",
    External_SKU_Code: "External SKU Code",
    Sync_Status: "Sync Status",
    Sync_Type: "Sync Type",
    Price: "Price",
    Payment_Type: "Payment Type",
    Inventory_Log: "Inventory Log",
    Safety_Inventory_Qty: "Safety Inventory Qty",
    Invoice_Header_Type: "Invoice Header Type",
    Invoicing_Method: "Invoicing Method",
    Personal: "Personal",
    Company: "Company",
    Invoice_Header: "Invoice Header",
    Company_Tax_No: "Company Tax No.",
    Payment_No: "Payment No.",
    Bank_Account: "Bank Account",
    Electronic: "Electronic",
    Paper: "Paper",
    Payment_Info: "Payment Info",
    Bank: "Bank",
    Invoice: "Invoice",
    Add_Payment: "Add Payment",
    Payment_Account: "Payment Account",
    Shipping_Info: "Shipping Info",
    R_sure_to_complete: "Are you sure you want to complete the return ?",
    Reminder: "Reminder",
    Return_Application_No: "Return Application No.",
    Refund_Application_No: "Refund Application No.",
    Return_Application_Status: "Return Application Status",
    Return_Application: "Return Application",
    Complete_Time: "Complete Time",
    Return_Complete: "Return Complete",
    Please_enter_node_code_name: "Please enter node code or node name",
    Node_Code: "Node code",
    Order_Type: "Order Type",
    Delivery_Info: "Delivery Info",
    Online_Store_Name: "Online Store Name",
    Create_Channel_Order: "Create Channel Order",
    Please_recheck_the_form: "Please recheck the form",
    Only_display_results_from_selected_store:
      "Only display results from selected store",
    Application: "Application",
    App_Name: "App Name",
    Choose_Member: "Choose Member",
    Choose_Store: "Choose Store",
    Transition: "Transition",
    Member_Code: "Member Code",
    Member_Name: "Member Name",
    Mobile: "Mobile",
    Add_Product: "Add Product",
    Total_Price: "Total Price",
    Sale_Price: "Sale Price",
    Product: "Product",
    Discount: "Discount",
    Discount_Losses: "Discount Losses",
    Amount: "Amount",
    Service_Store: "Service Store",
    Choose_member: "Choose member",
    Select_products: "Select products",
    Export: "Export",
    Required: "Required",
    // Active: "Active",
    // Inactive: "Inactive",
    Activate: "Activate",
    Deactivate: "Deactivate",
    // Action: "Actions",
    // Create: "Create",
    // Edit: "Edit",
    // Delete: "Delete",
    // Search: "Search",
    // Cancel: "Cancel",
    // Sure: "Sure",
    // Continue: "Continue",
    // Confirm: "Confirm",
    // Warning: "Warning",
    // Success: "Success",
    // no_empty: "Can not be empty",
    // Next: "Next",
    // Save: "Save",
    // please_select: "Please select ",
    Select: "Select",
    // Add: "Add",
    // Status: "Status",
    // confirm_delete: "Are you sure to delete?",
    // create_time: "Create Time",
    create_user: "Create User",
    // return: "Return",
    // View: "View",
    // promotion: "Promotion | Promotions",
    // deduction: "Deduction",
    // product_items: "Product Items",
    // price: "Price",
    // sale_price: "Sale Price",
    // qty: "Qty",
    // amount: "Amount",
    // payment: "Payment",
    // Method: "Method",
    Payment_method: "Payment method",
    Payment_Method: "Payment Method",
    // Time: "Time",
    // customer_code: "Customer Code",
    // Name: "Name",
    // resv_time: "Resv. Time",
    // order_amount: "Order Amount",
    // return_amount: "Return Amount",
    // store_name: "Store Name",
    // store: "Store #",
    // created_from: "Created from",
    // created_to: "Created to",
    // status: "Status",
    // customer: "Customer",
    // plate: "Plate #",
    // source: "Source",
    // payment_type: "Payment Type",
    // basic_info: "Basic Info",
    // payment_info: "Payment Info",
    // customer_info: "Customer Info",
    // order_promotion: "Order Promotion",
    // order_items: "Order Items",
    // Refund: "Refund",
    // refund: "Refund No.",
    // return_no: "Return No.",
    // items_to_refund: "Items to Refund",
    // change_log: "Change Log",
    // change: "Change",
    // User: "User",
    // date_and_time: "Date & Time",
    // refund_request_info: "Refund Request Info",
    // cancel: "Cancel",
    // sure: "Sure",
    // title: "Title",
    // type_store_name_or_code: "Type store name or code to search",
    // create_to: "Create to",
    // detail: "Detail",
    // approve: "Approve",
    // reject: "Reject",
    // payment_no: "Payment #",
    // refund_detail: "Refund Detail",
    // return_detail: "Return Detail",
    // return_request_info: "Return Request Info",
    // items_to_return: "Items to Return",
    // are_you_certain_to_cancel_the_order: "Are you certain to cancel the order?",
    // Ok: "Ok",
    // Reset: "Reset",
    // Shop_Discount: "Shop Discount",
    // Type_the_reason_for_cancel: "The reason of order cancel",
    // Complete: "Complete",
    // Sure_message: "Are you certain to do this?",
    // account: "Account",
    // time: "Time",
    // refund_amount: "Refund Amount",
    // amount_discount: "Amount Discount",
    // refund_apply_type: "Refund Apply Type",
    // bank: "Bank",
    // bank_account: "Bank Account",
    // Remark: "Remark",
    // Save_and_submit: "Save & submit",
    // Enter_order_code: "Enter order code",
    // Enter_channel_order_code: "Enter channel order code",
    // Order_code_is_required: "Order code is required",
    Channel_order_code_is_required: "Channel Order is required",
    // Submit_again: "Submit again",
    // Submit: "Submit",
    // type_reason_of_reject: "Type reason of reject",
    // Complete_time: "Complete Time",
    // payment_account: "Payment Account",
    // Transaction_Fee: "Transaction Fee",
    // More: "More",
    // Telphone: "Telephone",
    "Telphone_#": "Telephone No.",
    // Zipcode: "ZIP Code",
    Post_Code: "Post Code",
    // Region: "Region",
    // Address: "Address",
    // Adress: "Adress",
    // Carrier: "Carrier",
    Shipping_Number: "Shipping Number",
    // Country: "Country",
    // Province: "Province",
    // City: "City",
    // District: "District",
    Area: "Area",
    // Product_code: "Product Code",
    // Bar_code: "Barcode",
    "SKU_#": "SKU No.",
    SKU: "SKU",
    SKU_Item: "SKU Item",
    SKU_Name: "SKU Name",
    // Sub_order_number: "Sub Order No.",
    Deduction_amount: "Deduction Amount",
    Activity_code: "Activity Code",
    Discount_type: "Discount Type",
    Deduction_code: "Deduction Code",
    "Order_#": "Order No.",
    Order_Status: "Order Status",
    "Channel_Order_#": "Channel Order No.",
    "WMS_#": "WMS No.",
    Shop_Name: "Shop Name",
    Channel: "Channel",
    Routed_Node_Name: "Routed Node Name",
    Node_Name: "Node Name",
    "Mobile_#": "Mobile No.",
    SKU_Code: "SKU Code",
    Barcode: "Barcode",
    Brand_SKU_Code: "Brand SKU Code",
    Seller_SKU: "Seller SKU",
    Seller_SKU_Code: "Seller SKU Code",
    "Member_#": "Member No.",
    Channel_SKU_Code: "Channel SKU Code",
    "Channel_Sub_Order_#": "Channel Sub Order No",
    Org_not_empty_tips: "Please select orgCode first, and then operate",
    ShopName_not_empty_tips: "Please select shopname first, and then operate",
    Online_Stores_Name: "Online Stores Name",
    Are_you_sure_you_want_to_delete: "Are you sure you want to delete?",
    Total_Qty: "Total Qty",
    Delivery_Type: "Delivery Type",
    Import: "Import",
    External_Code: "External Code",
    Promotion_Amount: "Promotion Amount",
    Coupon: "Coupon",
    Shipping_Fee: "Shipping Fee",
    Handing_Charge: "Handing Charge",
    // required_num_msg: "To enter a number",
    // required_num_0: "Must be greater than 0",
    Customer_Account: "Customer Account",
    Rejected_Reason: "Rejected Reason",
    Payee: "Payee",
    Channel_Node: "Channel Node",
    hours: "h",
    Tax: "Tax",
    Start_Date: "Start Date",
    End_Date: "End Date",
    Create_Order_Fail: "Create Order Fail",
    Failure_Type: "Failure Type",
    Reason: "Reason",
    Order_Info: "Order Info",
    Are_you_sure_want_to_receive_this_order:
      "Are you sure you want to receive this order?",
    Are_you_sure_want_to_cancel_this_order:
      "Are you sure want to cancel this order",
    Please_enter_0_to_500_characters: "Please enter 0/500 characters",
    Please_enter_an_integer_greater_than_or_equal_to_1:
      "Please enter an integer greater than or equal to 1",
    // 以下未翻译
    Refund_Info: "Refund Info",
    Refund_History: "Refund History",
    Channel_Refund_Application: "Channel Refund Application",
    Channel_Return_Application: "Channel Return Application",
    Refundable_Amount: "Refundable Amount",
    Refund_Type: "Refund Type",
    Create_refund: "Create Refund",
    Change_Log: "Change Log",
    Refund_Method: "Refund Method",
    Online: "Online",
    Offline: "Offline",
    The_refund_amount_cannot_be_gr:
      "The refund amount cannot be greater than the refundable amount",
    Maximum_refundable_amount: "Maximum refundable amount: {amount}",
    Refund_Amount: "Refund Amount",
    Payee_Account: "Payee Account",
    Attachment: "Attachment",
    Attachments: "Attachments",
    The_refund_amount_must_be_equa:
      "The refund amount must be equal to the sum of the payment method.",
    Only_5_files_size_less:
      "Only 5 jpg/png files with a size less than {size} can be uploaded.",
    Products_Count: "{count} Products",
    Create_Refund: "Create Refund",
    Edit_Refund: "Edit Refund",
    Audit_Refund: "Audit Refund",
    Refund_Details: "Refund Details",
    Channel_Order_No2: "Channel Order No.{id}",
    Refund_No: "Refund No.{id}",
    Member_Code_no: "Member Code: {value}",
    Create_Time_by: "Create Time: {value}",
    Fail_to_Fulfill: "Fail to Fulfill",
    Return: "Return",
    Product_Items: "Product Items",
    Refund_Number: "Refund No.",
    Qty: "Qty.",
    Online_Shop_Name: "Online Shop Name",
    Back: "Back",
    Choose_Order: "Choose Order",
    Cannot_be_0: "The refund amount cannot be 0",
    Refund_Apply_No: "Refund Apply No.",
    Refund_Reason: "Refund Reason",
    Changes: "{count} Changes",
    No_changes: "No changes",
    Product_Code: "Product Code",
    products_Count: "{count} products",
    Items_of_Refund: "Items of Refund",
    Audit: "Audit",
    Are_you_sure_to_cancel: "Are you sure to cancel this refund?",
    Are_you_sure_to_approve: "Are you sure to approve this refund?",
    // Reject: "Reject",
    // Approve: "Approve",
    Transfer_Vouchers: "Transfer Vouchers",
    Cancel_Refund: "Cancel Refund",
    Reason_Rejection: "The reason for rejection",
    Only_5_files_can_uploaded:
      "Only 5 jpg/png files with a size less than 500kb can be uploaded.",
    InventorySyncLog: "Inventory Sync Log",
    Ext_SKU: "External SKU",
    Order_Shipment: "Order Shipment",
    Complete_Order: "Complete Order",
    Email: "Email",
    Member_Email: "Member Email",
    Point_Amount: "Point Amount",
    Order_Source: "Order Source",
    Total_Amount: "Total Amount",
    Optarion_Log: "Operation Log",
    Logistic_Company: "Logistic Company",
    R_sure_to_submit: "Are you sure you want to submit this change?",
    Yes: "Yes",
    No: "No",
    Fail: "Fail",
    Name: "Name",
    Enter_channel_order_code: "Enter channel order code",
    On_Hold: "On Hold",
    You_have_num_package: "You have {num} packages",
    No_package: "No package",
    Package: "Package",
    Payment_Channel: "Payment Channel",
    Hold_Reason: "Hold Reason",
    ChannelInventory: "Channel Inventory",
    DOAddressRouting: "DO Address Routing",
    O2OMapping: "O2O Mapping",
    FullStock: "Full Stock",
    Subtotal: "Subtotal",
    Total_Discount: "Total Discount",
    Order_Promotions: "Order Promotions",
    Promotions: "Promotions",
    Update_Error: "{X} update error",
    Please_enter_SKU_Code: "Please enter SKU Code",
    Package_Items: "Package Items",
    OrderNo: "Order No.",
    NodeInventory: "Node Inventory",
    Arey_sure_to_deliver: "Are you sure you want to delivered the order?",
    OrderFulfillmentRules: "Order Fulfillment Rules",
    ProductNum: "no products | 1 product | {count} products",
    Order_Details: "Order Details",
    Do_NO: "Do No. {code}",
    Create_Time_at: "Create Time: {date}",
    Change_Number: "no changes | 1 change | {count} changes",
    OrderStatusChanges: "The order status from {pre} to {curr}",
    WMSOutboundNode: "WMS Outbound Node",
    WMSOutboundTime: "WMS Outbound Time",
    Routed_Node: "Routed Node",
    TrackingNo: " Tracking No.",
    AUSureCancelDO: "Are you sure to cancel the DO?",
    Task_List: "Task List",
    invoice_info: "Invoice info",
    "Company_Tax_#": "Company Tax No.",
    Invoicing_Title_Type: "Invoicing Title Type",
    Invoicing_Title: "Invoicing Title",
    Is_Need_Invoice: "Is Need Invoice",
    Unpaid_Orders: "Unpaid Orders",
    Pending_Orders: "Pending Orders",
    Pending_Audit_Return: "Pending Audit Return",
    Pending_Audit_Refund_Result: "Pending Audit Refund",
    Wating_Orders: "Wating Orders",
    Wating_for_Reply: "Wating for Reply",
    Routing_Failed: "Routing Failed",
    Order_Picking: "Order Picking",
    Pending_Complete_Refund: "Pending COM. Refund",
    Picking_Failed: "Picking Failed",
    Waiting_Inbound: "Waiting Inbound",
    Pending_Audit_Refund: "Pending Audit Refund",
    Limit90days:
      "You can search orders of 90 days each time, please select the start and end time again",
    DefaultShow3Mounth: "Default display orders in the last 3 months",
    Fulfillment: "Fulfillment",
    Orders: "Orders",
    By_Online_Stores: "By Online Stores",
    By_Node: "By Node",
    EditReturn: "Edit Return",
    ReturnNo: "Return No. {no}",
    ReturnAmount: "Return Amount",
    ReturnInfo: "Return Info",
    ChannelReturnRequest: "Channel Return Request",
    ChannelSKUCode: "Channel SKU Code",
    SubOrderNo: "Sub Order No.",
    ReturnQTY: "Return Qty.",
    ShippingNo: "Shipping No.",
    OrderStatusIs: "The order {status}",
    PayStatus: "Payment Sataus",
    Unpaied: "Unpaied",
    Paied: "Paied",
    OnlineRefund: "Online Refund",
    OfflineRefund: "Offline Refund",
    MaxTips: "Maximum refundable amount: {amount}",
    OnlinePayMethod: "{label}(Offline)",
    Desc1:
      "The refund amount is the product amount by default, and the refund amount cannot exceed the actual paid amount.",
    Desc2: "Refundable amount = actually paid amount - refunded amount",
    Desc3:
      "When the refund is fully refunded <br /> Refund amount = product amount + shipping fee",
    Desc4: "Refund amount = product amount",
    Desc5: "Refundable shipping fee = order shipping fee-returned shipping fee",
    Please_enter_1_1000_order_no: "Please enter 1/1000 order no. E.g. 1,2,3",
    "External_Order_#": "External Order No."
  },
  Refund: {
    Refund: "Refund",
    Create_refund: "Create refund page",
    refund: "Refund #",
    return: "Return #",
    items_to_refund: "Items to Refund",
    change_log: "Change Log",
    change: "Change",
    User: "User",
    date_and_time: "Date & Time",
    refund_request_info: "Refund Request Info",
    can_be_create_refund:
      "The order could not be found. Please check if the order has been paid and cancelled.",
    after_complete:
      "Cannot edit after completing the order, please proceed with caution.",
    refund_remark: "Refund Remark",
    payee_bank: "Payee Bank",
    payee_account: "Payee Account",
    financial_refund_type: "Financial refund type",
    bankname_empry_msg: "Payee name cannot be empty",
    bankaccount_empry_msg: "Payee account cannot be empty",
    refundamount_empry_msg:
      "Refund amount cannot be empty and must be greater than or equal to 0",
    Return_Details: "Return Request Details",
    Create_Return_Application: "Create Return Request",
    Return_Reason: "Return Reason",
    Refund_Result: "Refund Result",
    Payment_Amount: "Payment Amount",
    bankmethod_empry_msg: "Payee method cannot be empty",
    transfer_voucher: "Transfer Voucher",
    Voucher: "Voucher",
    Confirm_In_Bound: "Confirm In Bound",
    Please_confirm_submit_refund_order:
      "Please confirm if submitting refund order",
    Are_you_sure_you_want_to_complete_the_return:
      "Are you sure you want to complete the return ?",
    The_order_status_is_created_cancelled_unpaid_cannot_create_a_refund:
      "The order status is created, cancelled, unpaid cannot create a refund",
    Inbound: "Inbound",
    Return_Request_No: "Return Request No.",
    Return_Request_Details: "Return Request Details",
    Refund_Request_Inbounded_Tips: "Are you sure this order has been inbounded?"
  },
  omscip: {
    Node_number: "Node #",
    Node_Name: "Node name",
    Node_Code: "Node code",
    Channel_Sku_Code: "SKU",
    Brand_Sku_Code: "Brand SKU Code",
    Bar_Code: "Barcode",
    "Node_#": "Node #",
    Shop_Name: "Shop Name",
    Available_qty: "Available Qty",
    Reserve_Qty: "Reserved Qty",
    Full_qty: "Full Qty",
    Reserve_inventory_in: "Reserve Inventory Info",
    Reserve_Time: "Reserve Time",
    Channel_Sales_Inventory: "Inventory Management",
    Import_inventory: "Import",
    Channel_Source: "Channel Source",
    Import_description:
      "You can import channel sale data to Inventory from a XLSX file. We recommend downloading the temple before running an import."
  },
  ChangePassword: {
    require_password: "New password is required",
    require_Original_password: "Current password is required",
    error_length_password: "Password length must be 8 to 20",
    error_contain_password:
      "Password must contain upper&lowercase letters, and number",
    Operation_Portal: "Operation Portal",
    Change_password: "Change Password",
    Original_Password: "Current Password",
    error_again_paswrod: "Inconsistent passwords twice",
    error_account_password: "Cannot contain username",
    rule_account: "Cannot contain username",
    rule_region: "Upper&lowercase letters, and numbers",
    rule_title: "New password must include:",
    rule_length: "8-20 characters",
    to_login: "Go to Login",
    change_success_info: "Now! You can now log in with your new password",
    change_success_title: "Change succeeded"
  },
  Pricing: {
    pricing: "Price Management",
    add_price: "Add price",
    Level_One: "Level One",
    Level_Two: "Level Two",
    Pricelevel: "Price Level",
    addPrice: "Add Price",
    delete_tips_msg:
      "There is unsaved data in the list. Deleting will refresh the page and the data will be lost. Are you sure you want to delete it?",
    code: "code:",
    miss_sku_code: "Missing SKU code",
    input_level_one: "Please input Level One",
    input_salePrice: "Please input sale price",
    miss_price_code: "Missing price code",
    batch_shelves: "Activate",
    batch_active_notice:
      "Please make sure you have saved the data you need first. Are you sure you want to activate these prices?",
    batch_deactive_notice:
      "Please make sure that you have saved the data you need first. Are you sure you want to deactivate these prices?",
    batch_empty: "Please select the price",
    batch_off_shelves: "Deactivate",
    no_active:
      "All the selected prices have been activated, so there is no need to repeat the operation",
    no_deactive:
      "All the selected prices have been dectivated, so there is no need to repeat the operation",
    Result: "Result",
    Action: "Action",
    failed: "Failed",
    fail: "Fail",
    Create: "Create",
    Edit: "Edit",
    Delete: "Delete",
    Search: "Search",
    Cancel: "Cancel",
    Continue: "Continue",
    Confirm: "Confirm",
    Warning: "Warning",
    no_empty: "Can not be empty",
    Next: "Next",
    Save: "Save",
    Active: "Active",
    Inactive: "Inactive",
    please_select: "Please select",
    Add: "Add",
    Status: "Status",
    confirm_delete: "Are you sure to delete?",
    image: "Image",
    type: "Type",
    logo: "Logo",
    Switch: "Switch",
    tenant: "Tenant",
    org: "Org",
    prev: "Previous",
    success: "Success",
    required_msg: "Is required",
    required_num_msg: "To enter a number",
    required_num_0: "Must be greater than 0",
    required_20_char: "Cannot exceed 20 characters",
    required_50_char: "Cannot exceed 50 characters",
    required_100_char: "Cannot exceed 100 characters",
    required_200_char: "Cannot exceed 200 characters",
    required_500_char: "Cannot exceed 500 characters",
    required_1000_char: "Cannot exceed 1000 characters",
    required_number_letter_dashes: "Can only be numbers, letters, dashes",
    num_be_init: "Sort must be an integer",
    reset: "Reset",
    ok: "OK",
    more: "More",
    add: "Add",
    yes: "Yes",
    no: "No"
  },
  Promotion: {
    Promotion: "Promotion",
    Promotion_type: "Promotion type",
    Promotion_status: "Promotion status",
    Sponsor: "Sponsor",
    Promotion_code: "Promotion code",
    "Start_date_&_end_date": "Start date & end date",
    enter_store_name: "seprated by ';'",
    Type: "Type",
    Code: "Code",
    Name: "Name",
    Start_date: "Start date",
    End_date: "End date",
    Store_names: "Store names",
    Basic_Info: "Basic Info",
    Enter_promotion_name: "Enter promotion name",
    Select_sponsor: "Select sponsor",
    Description: "Description",
    View_Display_Example: "View Display Example",
    Field_Display_Example: "Field Display Example",
    For_a_good_experience_please_pay_attention_to_control_the_text_length:
      "For a good experience, please pay attention to control the text length.",
    PDP: "PDP",
    Coupon: "Coupon",
    Promotion_editor: "Promotion editor",
    General_information: "General information",
    Promotion_name: "Promotion name",
    Promotion_sponsors: "Promotion sponsors",
    Time_condition: "Date time",
    Display_name: "Display name",
    Tag: "Tag",
    Store_condition: "Store condition",
    Select_all_stores: "Select all stores",
    Store_IDs: "Stores",
    Participant_condition: "Participant condition",
    Apply_to_all_participants: "Apply to all participants",
    Member_tags: "Member tags",
    Promotion_rules: "Promotion rules",
    Rule_type: "Rule type",
    Percent_off: "Percent off",
    Discount: "Discount",
    Promotion_constraints: "Promotion constraints",
    Max_times_one_single_user_can_participate:
      "Max. times one single user can participate",
    Max_amount_one_participating_allows: "Max. amount one participating allows",
    Max_times_of_participating_allows: "Max. times of participating allows",
    Date: "Date",
    Select_product: "Select product",
    Conditional_restriction: "Conditional restriction",
    Restrict_some_businesses: "Restrict some businesses",
    Select_stores: "Select stores",
    All_stores: "Select all stores",
    Condition_of_A: "Condition of A",
    Condition_of_B: "Condition of B",
    Select_all_product: "Select all products",
    Select_scope: "Select scope",
    Product: "Product",
    SKU: "SKU",
    Product_condition: "Product condition",
    Select_incentive_products: "Select incentive products",
    Select_brands: "Select brands",
    Select_categories: "Select categories",
    Product_codes: "Product codes",
    SKU_codes: "SKU codes",
    Method: "Method",
    No_constraints: "No constraints",
    Add_constraints: "Add constraints",
    Codes: "Codes",
    At_least_one_language:
      "At least input one 'activity name' in certain language",
    Please_add_at_least_one_rule: "At least set one rule",
    At_least_select_one_product: "At least select one product",
    By_item_Qty: "By item Qty.",
    By_order_amount: "By order amount",
    Unreasonable_value: "Unreasonable value",
    Layered: "Layered",
    Repeat: "Repeatable",
    Select_condition_products: "Product conditions",
    Enter_coupon_code_here: "Enter coupon code here, separate by ‘,’",
    Enter_qty_of_code: "Enter Qty. of code to be created",
    Max_times_per_user: "Max. times per user",
    Max_amount_total: "Max. amount total",
    Enter_display_description: "Enter display description",
    Enter_display_tag: "Enter display tag",
    description_name_vaildate_error:
      'The length limit is 256 characters. Special characters other than % space , " " ( ) ~!@#$%^&* are not allowed',
    description_label_vaildate_error:
      "Only enter numbers, letters, Chinese, spaces, ~!@#$%^&* and the maximum length is 100",
    Short_description: "Short description",
    Total_budget: "Total budget",
    Total_budget_of_the_promotion_campaign:
      "Total budget of the promotion campaign",
    Free: "Free",
    Duplicate: "Duplicate",
    Search_store: "Type store name to search",
    URL: "URL",
    sponsor_placeholder: "Enter sponsors, separated by ‘,’",
    special_same: "When same item qty. meets below conditions",
    special_total:
      "When total qty. of eligible items in cart meets below conditions",
    special_rule: "when qty. reaches",
    special_offer: "special offer",
    order_same_item: "Must be same item",
    maximum_daily_total: "Max. times for daily total",
    maximum_daily_total_checkout: "Max. times for daily total check out",
    extend_promo: "Extend promo",
    curEndDate: "Current end date:",
    edit_endDate: "Extend End Date",
    end_date_rule: "Cannot be earlier than the original end date",
    buy: "Buy ",
    pieces: " pieces ",
    next_one: " get next one for ",
    discount: "discount",
    off: "% off",
    next_one_free: " get next one for free",
    max_amount_discount: "Max. amount of discount",
    max_amount_discount_placeholder:
      "Max. amount of discount for every check out",
    giveaway_amount_type: "When order amount reaches required amount",
    giveaway_qty_type: "When same item reaches required qty.",
    choose_giveaway: "Choose giveaway",
    giveaway_promotion: "Giveaway promotion",
    giveaway_num: "Enter Qty. to give away",
    coupon_code: "coupon promotion code",
    choose_coupon_promotion: "Choose coupon promotion",
    promo_Name: "Promo Name",
    piece: "pcs",
    coupons: "Coupons",
    select: "Select",
    DefaultShow3Mounth: "Default display orders in the last 3 months"
  },
  Coupon: {
    Coupon: "Coupon",
    Release: "Release",
    Coupon_editor: "Coupon editor",
    Generate_coupon: "Generate coupon",
    Send_coupons: "Send Coupons",
    Coupon_creation: "Coupon creation",
    Coupon_creation_history: "Coupon creation history",
    Auto_create_coupon_code: "Auto create coupon code",
    Import_coupon_code: "Import coupon code",
    Coupon_expires_after_certain_days_since_aquisition:
      "Coupon expires after certain days since aquisition",
    Coupon_valid_between_certain_period: "Coupon valid between certain period",
    Coupon_created: "Coupon created",
    Enter_coupon_qty: "Enter coupon qty.",
    Enter_user_id_separated_by: "Enter user ID separated by ‘,’",
    Select_coupon_creation_time: "Select coupon creation time",
    All_user: "All user",
    Scope_user: "Selected users",
    Can_not_be_empty: "Can not be empty",
    Only_positive_integers_can_be_entered:
      "Must be a positive integer greater than 0",
    The_activity_has_ended: "The activity has ended",
    The_input_cannot_be_less_than_0_days:
      "The input cannot be less than 0 days",
    Only_positive_integers_greater_than_0_can_be_entered:
      "Only positive integers greater than 0 can be entered",
    Activity_has_not_yet_started_enter_up_to:
      "Activity has not yet started, enter up to",
    Days: "days",
    Available_start_time_cannot_be_less_than_activity_start_time:
      "Available start time cannot be less than activity start time",
    Available_end_time_cannot_be_greater_than_activity_end_time:
      "Available end time cannot be greater than activity end time",
    Coupons_for_all_members_are_limited_to_send_once_an_hour:
      "Coupons for all members are limited to send once an hour.",
    Coupons_for_some_members_are_limited_to_send_once_every_10_minutes:
      "Coupons for some members are limited to send once every 10 minutes.",
    Are_you_sure_you_want_to_send_the_coupon_to_all_members:
      "Are you sure you want to send the coupon to all members?",
    Are_you_sure_you_want_to_send_the_coupon_to_some_members:
      "Are you sure you want to send the coupon to some members？",
    byUser: "By ID",
    byMobile: "By Mobile #",
    Enter_mobile_separated_by: "Enter mobile separated by ‘,’"
  },
  ProductPicker: {
    Condition_products: "Condition products",
    Please_select_at_least_options: "Please select at least one option",
    Download_Template: "Download Template",
    Select_a_file: "Select a file",
    Will_overwrite_the_p:
      "Will overwrite the previously imported data, confirm to upload ?",
    Attributes: "Attributes",
    Only_select_attribut:
      "Only select attribute type can used as a filter condition.",
    Only_select_up_to_th:
      "Only select up to three product attributes as a filter condition",
    Add_attribute: "Add attribute",
    Please_select_at_least_attribute:
      "Please select at least one attribute value",
    Manual: "Manual",
    Import: "Import",
    Only_display_selecte: "Only display selected items",
    Enter_product_name_o: "Enter product name or code to search",
    Product_code: "Product code",
    Product_name: "Product name",
    You_can_select_produ:
      "You can select products from a XLSX file. We recommend downloading the temple before ",
    Imported_Products: "Imported Products",
    Enter_SKU_code_to_se: "Enter SKU code to search",
    Sku_name: "Sku name",
    Sku_code: "Sku code",
    You_can_select_SKU_f:
      "You can select SKU from a XLSX file. We recommend downloading the temple before",
    Imported_Skus: "Imported Skus"
  },
  O2OOrder: {
    Order: "Order",
    order: "Order",
    Store: "Store",
    "Store_#": "Store No.",
    Channel_Order: "Channel Order",
    "Channel_Order_#": "Channel Order No.",
    Channel_order_details: "Channel Order Details",
    Service_order: "Service Order",
    Create_service_order: "Create Service Order",
    store_name: "Store Name",
    Shop_name: "Shop Name",
    created_from: "Created from",
    created_to: "Created to",
    Fulfill_status: "Fulfill Status",
    status: "Status",
    customer: "Customer",
    plate: "Plate #",
    source: "Source",
    amount: "Amount",
    payment_type: "Payment Type",
    basic_info: "Basic Info",
    payment_info: "Payment Info",
    customer_info: "Customer Info",
    order_promotion: "Order Promotion",
    order_items: "Order Items",
    Store_code: "Store code",
    Channel: "Channel",
    payment_account: "Payment Account",
    Order_discount: "Order discount",
    Order_details: "Order Details",
    Service_Order_details: "Service Order Details",
    Refund_details: "Refund details",
    Refund_Type: "Refund Type",
    Refund_Apply_Type: "Refund Type",
    Bank_name: "Bank name",
    Bank_account: "Bank account",
    Refund_amount: "Refund Amount",
    Basic_info: "Basic Info",
    Order_status: "Order status",
    Payment_account: "Payment Account",
    Coupon_amount: "Coupon Amount",
    Payment_status: "Payment Status",
    Cancel_reason: "Cancel Reason",
    Seller_notes: "Seller Notes",
    Buyer_notes: "Buyer Notes",
    Service_order_change_log: "The service order status from",
    Order_change_log: "The order status from",
    To: "to",
    Order_success: "order successfully",
    Service_order_success: "service order successfully",
    Create_service_order_success: "Create service order successfully",
    Create_order_success: "Create order successfully",
    Create_delivery_order_success: "Create delivery order successfully",
    Create_return_order_success: "Create return order successfully",
    Carrier: "Carrier",
    "Tracking_#": "Tracking No.",
    Ship_order: "Ship Order",
    Shipped: "Shipped",
    Delivered: "Delivered",
    Delivery_Failed: "Delivery Failed",
    Ready_to_Ship: "Ready to Ship",
    Enter_ship_number: "Please enter Shipping number",
    Order_is_canceled: "Order is canceled!",
    Enter_reason: "Enter reason",
    Enter_seller_notes: "Enter seller notes",
    Sub_type: "Sub Type",
    Paymt_type: "Payment Type",
    Order_type: "Order Type",
    Freight: "Freight",
    Confirm_Payment: "Confirm Payment",
    Receive_Order: "Receive Order",
    Shipping_number_and_carrier__carrier_cannote_be_empty:
      "Shipping number and carrier cannot be empty",
    Delivery_information_cannot_be_empty:
      "Delivery information cannot be empty.",
    Status_order_successfully: "{status} order successfully.",
    Status_service_order_successfully: "{status} service order successfully.",
    Status_delivery_order_successfully: "{status} delivery order successfully.",
    Status_return_order_successfully: "{status} return order successfully.",
    Order_change_log_status: "The order status from {exStatus} to {status}.",
    Service_change_log_status:
      "The service order status from {exStatus} to {status}.",
    Delivery_change_log_status:
      "The delivery order status from {exStatus} to {status}.",
    Return_change_log_status:
      "The return order status from {exStatus} to {status}."
  },
  "20200813": {
    Product: {
      create_product: "Create Product",
      create_step1: "Step 1: Create Product",
      create_step2: "Step 2: Create SKU",
      basic_info: "Basic Info",
      basic_note: "Click this icon “{icon}“  to edit multi-languages.",
      no_attribute: "No attribute added.",
      media_info:
        "The size of pictures and videos does not exceed 1000kb, and support mainstream picture and video formats.",
      next_step: "Next Step",
      SKU_nfo: "SKU Info",
      Availability: "Availability",
      pc_media: "PC Media",
      choose_family: "Choose a product family to fast create a product.",
      family_select: "Product Family",
      skip: "Skip",
      multiInfo: "Multi-Languages",
      delete_info: "SKU can be deleted after deactivation.",
      SKU_media: "SKU Media",
      previous: "Previous",
      save_product: "Save Product",
      save_SKU: "Save SKU",
      edit_product: "Edit Product",
      copy_code: "Copy Code",
      copy_success: "Copy success",
      empty_sku: "Add at least one SKU to save",
      activated: "Activated",
      deactivated: "Deactivated",
      edit_SKU: "Edit SKU"
    }
  },
  DO: {
    DO: "DO",
    Delivery_Order: "Delivery Order",
    Delivery_Order_Details: "Delivery Order Details",
    "DO_#": "DO No.",
    DO_Status: "DO Status",
    DO_Type: "DO Type",
    Reroute: "Reroute",
    DO_Info: "DO Info",
    System_Node: "System Node",
    Outbound_Node_Name: "Outbound Node Name",
    Error_Reason: "Error Reason",
    Sync_WMS_Time: "Sync WMS Time",
    Actual_Node_Name: "Actual Node Name",
    Outbound_Time: "Outbound Time",
    Is_COD: "Is COD",
    Check_Logistics: "Check Logistics",
    Logistics_Info: "Logistics Info",
    Are_you_sure_want_to_complete_the_DO:
      "Are you sure want to complete the DO ?",
    Batch_cancel_all_success: "All canceled successfully",
    Batch_cancel_tips:
      "{successSize} data cancellations succeeded, {failSize} data cancellations failed",
    Batcg_route_selectedRow_empty_tips:
      "Please select Routing Failed & Picking Failed DO for rerouting"
  },
  "20200917": {
    Product: {
      channel: "Channel:",
      add_channel: "Add Channel",
      channel_category: "Channel Category",
      channel_category_colon: "Channel Category:",
      channel_brand_colon: "Channel Brand: ",
      page_refresh:
        "Switching will lose your unsaved inputs. Are you sure to continue?",
      switch_notice:
        "After saving the channel category can not be modified, whether to save?",
      select_channel: "Select Channel",
      select_category: "Select Category",
      switch: "Switch",
      sku_notice:
        "Sku and attributes can only be added under the master channel.",
      disabled_sku:
        " Channel product information have not yet saved, can not edit and publish SKU.",
      no_data: "No data",
      publish: "Publish",
      save_publish: "Save Product and Publish Product&SKU",
      save_publish_notice:
        "Are you sure you want to save product and publish product & SKU?",
      channelProductCode: "Channel Product Code",
      noCategoty: "Please select channel category first"
    },
    Import: {
      channel_info: "Channel Info"
    }
  },
  Family: {
    title: "Family",
    Name: "Name",
    search_info: "Type family name to search",
    create_family: "Create Family",
    edit_family: "Edit Family",
    product_attribute: "Product Attribute",
    SKU_attribute: "SKU Attribute",
    family_name: "Family Name",
    page_info:
      "Creating a product family can help you quickly add attributes when creating a new product.",
    delete_notice: "Are you sure you want to delete it?",
    items_selected: " items selected"
  },
  DORoutingRules: {
    // ---------0806新加 Start -------
    Reply_to_Review: "Reply to Review",
    Reply_to_Review_Notice:
      "Notice! Your reply will be showed on the product detail page.",
    Seller_replied: "Seller replied",
    Hide_on_Feed: "Hide on Feed",
    Show_on_Feed: "Show on Feed",
    Reply: "Reply",
    Rating: "Rating",
    Content: "Content",
    Products: "Products",
    Consignee: "Consignee",
    Cancel_Orders_Overtime: "Cancel Orders Overtime",
    Is_Need_Refund_Application: "Is Need Refund Application",
    place_an_order_No_delivery_after_X_hours_cancelled:
      " place an order No delivery after X hours, the order is automatically cancelled.",
    // ----------- end --------------
    DO_Routing_Rules: "DO Routing Rules",
    Create_Routing_Setting: "Create Routing Setting",
    Edit_Routing_Setting: "Edit Routing Setting",
    Split_Order_Delivery: "Split Order Delivery",
    Split_Order_Giveaway: "Split Order Giveaway",
    Cancel_Out_of_Stock: "Cancel Out of Stock",
    Partial_Shipment: "Partial Shipment",
    Pickup_Method: "Pickup Method",
    By_Online_Stores: "By Online Stores",
    By_Area: "By Area",
    Delivery_order_can_be_routed_to_multiple_warehouse_shipments:
      "Delivery order can be routed to multiple warehouse shipments",
    Delivery_order_contains_gifts:
      "Delivery order contains gifts, whether to allow multi-warehouse delivery",
    WMS_partial_delivery:
      "WMS partial delivery, whether to cancel out of stock list",
    Whether_to_allow_WMS_partial_shipment:
      "Whether to allow WMS partial shipment",
    Back_Order_Reallocation: "Back Order Re-allocation",
    Shipment_By_Channel_Warehou: "Shipment By Channel Warehouse",
    Shipment_By_Channel_Warehou_tips:
      "When the channel order specifies the warehouse, it must be shipped according to the channel designated warehouse, and the warehouse cannot be exchanged"
  },
  store: {
    Basic: {
      OK: "OK",
      CreateAdminSuccess:
        "User name {account}, initialization password has been sent to your email {email}",
      FirstName: "First Name",
      LastName: "Last Name",
      AdministratorAccount: "Admin Account",
      Email: "Email",
      AddAdministratorAccount: "Add Admin Account",
      open_status: "Open Status",
      Success: "Success",
      Online_Store: "Online Store",
      Offline_Store: "Offline Store",
      OfflineStoreName: "Offline Store Name",
      OfflineStoreCode: "Offline Store Code",
      Tags: "Tags",
      OpenStatus: "Open Status",
      Start_Time: "Start Time",
      End_Time: "End Time",
      Avaliability: "Avaliability",
      Dou_want_deactivate_store: "Do you want to deactivate the store ?",
      Dou_want_close_store: "Do you want to close the store ?",
      Yes: "Yes",
      No: "No",
      AddProducts: "Add Products",
      AddTags: "Add Tags",
      SelectProducts: "Select Products",
      Cancel: "Cancel",
      BasicInfo: "Basic Info",
      CreateOfflineStore: "Create Offline Store",
      EditOfflineStore: "Edit Offline Store",
      Address: "Address",
      ManagerInfo: "Manager Info",
      PostCode: "Post Code",
      Save: "Save",
      StoreCoverPhoto: "Store Cover Photo",
      Only_n_files_size_less:
        "Only {count} jpg/png files with a size less than {size} can be uploaded.",
      PleaseEnterDigits:
        "Please enter 8~16 digits or characters as the account number",
      OperationSetting: "Operation Setting",
      Account: "Account",
      Required: "Required",
      Create_time_at: "Create Time: {createTime}",
      StoreCodeIs: "Store Code: {storeCode}",
      OfflineStoreProduct: "Offline Store Product",
      Store_Search_Key_Placeholder: "Store Name"
      // Store_Search_Key_Placeholder: "Store Name/Store Code/External Code"
    },
    Common: {
      WMS_System: "WMS System",
      open_status: "Open Status",
      Success: "Success",
      Reset: "Reset",
      Action: "Actions",
      Create: "Create",
      Edit: "Edit",
      Delete: "Delete",
      Search: "Search",
      Cancel: "Cancel",
      cancel: "Cancel",
      Continue: "Continue",
      Confirm: "Confirm",
      Warning: "Warning",
      no_empty: "Can not be empty",
      Next: "Next",
      Save: "Save",
      please_select: "Please select ",
      Add: "Add",
      Status: "Status",
      confirm_delete: "Are you sure to delete?",
      create_time: "Create Time",
      return: "Return",
      View: "View",
      sure: "Sure",
      title: "Title",
      country: "Country",
      province: "Province",
      city: "City",
      zip_code: "Zip Code",
      addr_1: "Addr1",
      addr_2: "Addr2",
      first_name: "First Name",
      last_name: "Last Name",
      mobile_no: "Mobile No.",
      e_mail: "EMail",
      tax_id: "Tax ID",
      bank_name: "Bank Name",
      acc_name: "Account Name",
      acc_no: "Account No.",
      save_next: "Save & Next",
      car: "Car",
      Motocyle: "Motocyle",
      store_name_or_code: "Store name or code",
      reset: "Reset",
      save: "Save",
      finish: "Finish",
      store_perferences: "Store Perferences",
      change_vat: "Charge VAT",
      are_you_sure: "Are you sure?",
      actite: "Activate",
      reset_pass: "Reset Password",
      are_u_sure_to_active_shop_status:
        "Are you certain to change the store's status?",
      Ok: "Ok",
      Longitude: "Longitude",
      Latitude: "Latitude",
      Activate: "Activate",
      Inactivate: "Inactivate",
      Active: "Active",
      Inactive: "Inactive",
      Authorized: "Authorized",
      Unauthorized: "Unauthorized",
      Required: "Required",
      More: "More",
      Email: "Email",
      Mobile: "Mobile",
      Telephone: "Telephone No.",
      Choose_Org: "Choose Org",
      Region: "Region",
      Is_Authorized: "Is Authorized",
      Availability: "Availability",
      Start_Date: "Start Date",
      End_Date: "End Date",
      Create_Time: "Create Time",
      Basic_Info: "Basic Info",
      Import: "Import",
      Import_description:
        "We recommend downloading the temple before running an import."
    },
    Store: {
      store: "Store",
      Store_Code: "Store Code",
      manager: "Manager",
      Manager_Account: "Manager Account",
      location: "Location",
      type_to_search: "Type store name or code to search",
      create_new_store: "Create new store",
      store_info: "Store Infomation",
      store_name: "Store Name",
      Business_phone: "Business Phone No.",
      Google_coordinates: "Google Coordinates",
      Store_manager: "Store Manager",
      edit_store: "Edit Store",
      Settlement: "Settlement",
      Inactivate: "Inactivate",
      Manage_services: "Manage Services",
      Store: "Store",
      Click_to_Collect: "Pickup in Store",
      PickupinStore: "Pickup in Store",
      Seller_Delivery: "Seller Delivery",
      edit_store_services: "Edit Store Services",
      External_Store_Code: "External Store Code",
      Bank_Branch_Name: "Bank Branch Name"
    },
    EditServices: {
      Store_Operation_Center: "Store Operation Center",
      enter_and_submit: "Please enter and submit",
      store_code:
        "Please enter store code (press enter to get the existing list):",
      service_type: "Please enter service type (separated by comma):",
      example: "elample : typeA , typeB ,TypeC"
    },
    OnlineStore: {
      Online_Stores: "Online Stores",
      Online_Stores_Name: "Online Stores Name",
      Channel: "Channel",
      "Online_Stores_#": "Online Stores Code",
      Status: "Status",
      Create_Time: "Create Time",
      Create_Online_Stores: "Create Online Stores",
      Edit_Online_Stores: "Edit Online Stores",
      Sales_Model: "Sales Model",
      Authorization: "Authorization",
      Start_Authorization: "Start Authorization",
      Save_Authorization: "Save & Authorization",
      "External_Stores_#": "External Stores Code",
      Authorization_Status: "Authorization Status",
      Authorization_Expiration_Time: "Authorization Expiration Time",
      Congratulations: "Congratulations !",
      The_authorization_is_successful: "The authorization is successful.",
      Back_to_List: "Back to List",
      Authorization_Result: "Authorization Result",
      Authorization_failed: "Authorization failed",
      After_xx_seconds_automatically_return_to_the_list:
        "After <span>{number}</span> seconds, automatically return to the list.",
      Repeated_authorization:
        "Repeated authorization, authorized shop has been bound to {name} shop, please check.",
      Please_click_start_authorization_to_authorize:
        "Please click start authorization to authorize .",
      BliBli_Authorization: "BliBli Authorization",
      Token: "Token",
      History_Token: "History Token",
      Expiration_Time: "Expiration Time"
    },
    exportPage: {
      export: "Export",
      success_export: "Export request submitted successfully.",
      export_notice_title: "Export Products",
      export_submitted:
        "After exporting, please go to the “Export” menu to check the job status and download product file.",
      export_all: "You are requesting to export all products.",
      export_filter: "You are requesting to export filtered products.",
      view_export: "View Export Status"
    }
  }
};
